import {
  ItemSetQuestionPropertiesLocationType,
  type ItemSetQuestionPropertiesStatus,
  useGetItemSetQuestionPropertiesByStatusAndLocationQuery,
} from '@exam-management/graphql';
import { useQBankStructure } from '@exam-management/qbs-provider';
import { Loading, Box } from '@shared/components';

import { useQBankStructureDashBoardSearchParams } from '../../hooks';
import { QBankStructureDashBoardNavigationTabs } from '../qbank-structure-dashboard-navigation-tabs';
import { QBankStructureItemSetQuestionDashboardTable } from '../qbank-structure-item-set-question-dashboard-table';

export default function QBankStructureItemSetQuestionDashBoard() {
  const { qBankStructureInformation } = useQBankStructure();
  const [{ status }] = useQBankStructureDashBoardSearchParams();
  const { data, loading } = useGetItemSetQuestionPropertiesByStatusAndLocationQuery({
    variables: {
      input: {
        status: status as ItemSetQuestionPropertiesStatus,
        qBankStructureId: qBankStructureInformation.id,
        locationType: ItemSetQuestionPropertiesLocationType.QbankStructureLevelItem,
      },
    },
  });

  return (
    <Box
      sx={(theme) => ({
        width: '100%',
        border: `1px solid ${theme.palette.grey[300]}`,
        borderRadius: theme.shape.rounded(2),
        overflow: 'hidden',
      })}
    >
      <QBankStructureDashBoardNavigationTabs
        questionStatuses={['DRAFT', 'PUBLISHED', 'UNPUBLISHED', 'DISABLED']}
      />
      {loading ? (
        <Box sx={(theme) => ({ p: theme.spacing(6) })}>
          <Loading />
        </Box>
      ) : (
        <QBankStructureItemSetQuestionDashboardTable
          data={data?.qctGetItemSetQuestionPropertiesByStatusAndLocation ?? []}
        />
      )}
    </Box>
  );
}
